import PrivateImage from './PrivateImage';

export default PrivateImage;
